query AvailableCardCompanies($filter: AvailableCardCompaniesRecordFilter) {
  availableCardCompanies(filter: $filter) {
    nodes {
      id
      name
      isManualProcess
    }
  }
}
